import React from 'react';
import PropTypes from 'prop-types';
import HighLow from '../../../assets/images/products/high_low.svg';
import LowHigh from '../../../assets/images/products/low_high.svg';
import Recent from '../../../assets/images/products/circular-wall-clock.svg';
import FilterIcon from '../../../assets/images/common/icons/filter.svg';
import ProductReviewList from './ProductReviewList';

function LoggedoutProductReviewsContainer({ reviews,
    reviewCount,
    publicClickAction }) {
    return (<>
        <div className="product__reviews__sort">
            <div>
                <button className="product__reviews__sort__btn" onClick={publicClickAction}>
                    <img src={Recent} alt="recent sort" />
                    RECENT
                </button>
                <button className="product__reviews__sort__btn" onClick={publicClickAction}>
                    <img src={HighLow} alt="high rating sort" />
                    HIGH TO LOW
                </button>
                <button className="product__reviews__sort__btn" onClick={publicClickAction}>
                    <img src={LowHigh} alt="low rating sort" />
                    LOW TO HIGH
                </button>
            </div>
                <button className="product__reviews__sort__btn"
                    onClick={publicClickAction}>
                    <img src={FilterIcon} alt="filters" />
                    Filters
                </button>
        </div>
        { reviews
            && !!reviews.length
            && <ProductReviewList handleReviewClick={publicClickAction} reviews={reviews} /> }
        { !!reviewCount
            && reviewCount > 5
            && <button
                    className="product__section product__reviews__load-more"
                    disabled={reviews.hasEnd || reviews.fetching}
                    onClick={publicClickAction}>
                    Load More Reviews
        </button> }
    </>)
};

LoggedoutProductReviewsContainer.propTypes = {
    reviews: PropTypes.array,
    publicClickAction: PropTypes.func,
    reviewCount: PropTypes.number
}

export default LoggedoutProductReviewsContainer;